module.exports = __webpack_public_path__ + "pending_token.099b9e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/pending_token.png
// module id = 920
// module chunks = 0